import React, { ReactNode } from "react";
import { hexToRgba } from "../../lib/hexToRgba";

const SingleSelectPill = ({
  children,
  isSelected,
  theme,
}: {
  children: ReactNode;
  isSelected: boolean;
  theme: string[];
}) => {
  return (
    <div
      style={{
        backgroundColor: isSelected ? theme[0] : hexToRgba(theme[0], 0.1),
      }}
      className={`p-2 flex  flex-1 h-full cursor-pointer items-center justify-center  ${
        isSelected ? " text-white font-semibold" : ""
      } font-normal rounded-lg`}
    >
      {children}
    </div>
  );
};

export default SingleSelectPill;
